import { PayloadAction } from '../../../store.model';
import { ActionType } from '../power-bi.action';
import { PowerBiState } from '../power-bi.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: PowerBiState,
    action: PayloadAction<ActionType.POWER_BI__RELOAD, Reload>,
): PowerBiState {
    return {
        ...state,
        pending: {
            ...state.pending,
            reload: true,
        },
    };
}

export function reloadResultReducer(
    state: PowerBiState,
    action: PayloadAction<ActionType.POWER_BI__RELOAD_RESULT, ReloadResult>,
): PowerBiState {
    try {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            powerBiReports: action.payload.powerBiReports,
        };
    } catch {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
        };
    }
}
